<template>
    <div class="user">
        <Modal
            v-model="showDelModal"
            :title="$t('confirmDel')"
            @on-ok="showDelModal=false;deleteUser(userIdToDel);"
            @on-cancel="showDelModal=false"
        >
            <p>{{$t('confirmDel')}}</p>
        </Modal>

        <div class="search">
            {{$t('agent.phoneKefu')}}{{$t('account')}}:<Select v-model="search.kefu_id" style="width:200px">
                 <Option value="0" >{{$t('pleaseSelect')}}</Option>
                <Option v-for="item in kefuList" :value="item.id" :key="item.id">{{ item.username }}</Option>
            </Select>
            {{$t('status')}}：<Select v-model="search.status" style="width:200px">
                <Option value="" >{{$t('pleaseSelect')}}</Option>
                <Option value="0" >{{$t('unused')}}</Option>
                <Option value="1" >{{$t('used')}}</Option>
            </Select>
            <Button type="primary" @click="serach()">{{$t('searchText')}}</Button>
            <Button type="primary" class="add_user" icon="md-add" @click="show_add_user = true">{{$t('add')}}{{$t('menu.inviteCode')}}</Button>
        </div>
        <Table border :columns="columns12" :data="data6">
            <template slot-scope="{ row }" slot="status">
                <Tag color="green" v-if="row.status==0">{{$t('unused')}}</Tag>
                <Tag color="red" v-else>{{$t('used')}}</Tag>
            </template>
        </Table>
        <div class="page">
            <Page
                :total="totalItems"
                :page-size="itemsPerPage"
                show-elevator
                :current="currentPage"
                @on-change="loadData"
            />
        </div>
        <Modal v-model="show_add_user" :title="$t('add')+$t('menu.inviteCode')" @on-ok="add_user">
            <Form :model="modalAdd" :label-width="100">
                <Form :model="modalAdd" :label-width="100">
                    <FormItem :label="$t('agent.phoneKefu')">
                           <Select v-model="modalAdd.kefu_id" style="width:200px">
                                <Option v-for="item in kefuList" :value="item.id" :key="item.id">{{ item.username }}</Option>
                            </Select>
                    </FormItem>
                    <FormItem :label="$t('num')">
                        <Input type="text" v-model="modalAdd.num"></Input>
                    </FormItem>
                </Form>
            </Form>
        </Modal>
    </div>
</template>


<script>
export default {
    data() {
        return {
            showDelModal: false,
            userIdToDel: 0,
            currentPage: 1,
            totalItems: 0,
            totalPages: 1,
            totalItems: 1,
            itemsPerPage: 10,
            kefuList:[],
            search:{
                kefu_id:0,
                status:''
            },
            searchParm:{

            },
            columns12: [
                {
                    title: "ID",
                    key: "id"
                },
                {
                    title: this.$i18n.t('agent.agentAccout'),
                    key: "username"
                },
                  {
                    title: this.$i18n.t('menu.inviteCode'),
                    key: "code"
                },

                {
                    title: this.$i18n.t('status'),
                    key: "status",
                    slot:"status"
                }
            ],
            data6: [],
            modalAdd: {
                kefu_id: 0,
                num: 10
            },
            modalEdit:{
                user_id:'',
                pass:''
            },
            show_add_user: false,
            show_edit_pass:false
        };
    },
    mounted() {
        this.loadData(1);
    },
    methods: {
        serach(){
            this.searchParm = JSON.parse(JSON.stringify(this.search));
            this.loadData(1);
        },
        loadData(page) {
            this.currentPage = page;
            let path = this.$path.invite_code;
            let query = Object.assign({"page":this.currentPage},this.searchParm);
            //let query = new URLSearchParams(queryObj);
            //console.log(query);
            //this.search.kefu_id=0;
            //this.search.status ='';
            this.$get(path, query).then(res => {
                if (res.data) {
                    this.data6 = res.data.list;
                    this.kefuList = res.data.kefuList;
                    const that=this;

                    this.totalItems = res.data.pageObj.totalSize;
                    this.itemsPerPage = res.data.pageObj.pageSize;
                } else {
                    this.$Message.error(this.$i18n.t('dataFailed'));
                }
            });
        },
        add_user() {
            this.$post(this.$path.invite_code_add, this.modalAdd).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                    this.modalAdd = {
                        kefu_id:0,
                        num:10
                    }
                }
            });
        },
    }
};
</script>


<style lang="scss" scoped>
.search {
    margin-bottom: 20px;
    .add_user {
        float: right;
    }
}
.page {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/invite/invite.vue